export const TRIGGER_HOVER = 'TRIGGER_HOVER';
export const CLEAR_HOVER = 'CLEAR_HOVER';
